import SFlex from 'components/opinionless/SFlex'
import SBox from 'components/opinionless/SBox'
import { SStyled } from '../../../styles/theme'
import SText from 'components/opinionless/SText'
import SButton from 'components/opinionless/SButton'

export const InputRow = SStyled(SFlex)`
    flex-direction: row;

    ${(p) => `
        @media screen and (max-width: ${p.theme.breakpoints[0]}) {
            flex-direction: column;
        }
    `}
`
export const Container = SStyled(SBox)`
    width: 100%;

`

export const STextTitle = SStyled(SText)`
    width: 100%;
    max-width: 472px;
    min-height: 38px;
    margin-bottom: 30px;

`

export const STextBody = SStyled(SText)`
margin-bottom: 30px;
min-height : 38px;
`

export const SButtonPrevious = SStyled(SButton)`
padding: 0px 0px 0px 0px;
text-align: left;
max-width: 100px;

`

export const STextListItemBody = SStyled(SText)`
min-height : 20px;
`
